import './qbo-account.scss';
import { useContext, useEffect, useState } from 'react';
import { QBOAccount, QBOItemType } from '../../clients/quipli-service/qbo/qbo';
import { useQboApi } from '../../clients/quipli-service/qbo/qbo-api-v1';
import { Spinner } from '../../components/spinner/spinner';
import './qbo-item-income-account.scss';
import { QboItemIncomeAccount } from './qbo-item-income-account';
import { Typography } from '../../components/typography/typography';
import { Product } from '../../clients/quipli-service/product/product';
import { useAPI } from '../../clients/quipli-service/quipli-service-client';
import { TenantContext } from '../../context/tenant-context';
import { toast } from '../../util/toasts';
import { ItemGeneralLedgerTransactionType } from '../../clients/quipli-service/accounting/accounting';

export const QboProductIncomeAccount = ({ productId }: { productId: number }) => {
  const { configuration } = useContext(TenantContext);
  const [product, setProduct] = useState<Product>();
  const [accounts, setAccounts] = useState<QBOAccount[] | undefined>();
  const [splitSaleRental, setSplitSaleRental] = useState<boolean>();
  const { listAccounts, getItemIncomeAccount } = useQboApi();
  const { getProduct } = useAPI();
  let qboEnabled = false;

  // @hipaa-exclude-start
  if (configuration?.qboEnabled) {
    qboEnabled = true;
  }

  useEffect(() => {
    if (qboEnabled) {
      listAccounts()
        .then((accounts) => {
          setAccounts(accounts);
        })
        .catch((e) => {
          console.error(`Error loading QuickBooks accounts`, e);
          toast(`Error loading QuickBooks accounts`, 'error');
        });
      Promise.all([
        getItemIncomeAccount(QBOItemType.Product, productId.toString(), ItemGeneralLedgerTransactionType.Rental),
        getItemIncomeAccount(QBOItemType.Product, productId.toString(), ItemGeneralLedgerTransactionType.Sale),
        getProduct(productId),
      ]).then(([rentalIncomeAccount, saleIncomeAccount, product]) => {
        setSplitSaleRental(
          rentalIncomeAccount?.id !== saleIncomeAccount?.id ||
            (product.allowSale && !product.allowRent) ||
            (!product.allowSale && product.allowRent),
        );
        setProduct(product);
      });
    }
  }, [configuration?.qboEnabled]);
  // @hipaa-exclude-end

  return (
    <div className="qbo-item-income-account container-v2">
      {qboEnabled && accounts && product && (
        <div className="flex flex-end flex-column" style={{ alignItems: 'flex-end' }}>
          {splitSaleRental ? (
            <>
              {product.allowRent && (
                <QboItemIncomeAccount
                  itemType={QBOItemType.Product}
                  itemId={productId.toString()}
                  transactionType={ItemGeneralLedgerTransactionType.Rental}
                  accounts={accounts}
                  label="QuickBooks Rental Income Account"
                />
              )}
              {product.allowSale && (
                <QboItemIncomeAccount
                  itemType={QBOItemType.Product}
                  itemId={productId.toString()}
                  transactionType={ItemGeneralLedgerTransactionType.Sale}
                  accounts={accounts}
                  label="QuickBooks Sale Income Account"
                />
              )}
            </>
          ) : (
            <>
              <QboItemIncomeAccount
                itemType={QBOItemType.Product}
                itemId={productId.toString()}
                accounts={accounts}
                label="QuickBooks Income Account"
              />
              <Typography type={'text-xs'}>
                <a onClick={() => setSplitSaleRental(!splitSaleRental)}>Split Sale/Rental</a>
              </Typography>
            </>
          )}
          <QboItemIncomeAccount
            itemType={QBOItemType.Product}
            itemId={productId.toString()}
            transactionType={ItemGeneralLedgerTransactionType.Expense}
            accounts={accounts}
            label="QuickBooks Expense Account"
          />
        </div>
      )}
      {qboEnabled === undefined && <Spinner />}
    </div>
  );
};
